import { useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type ViewTypeName } from '@air/api/types';

import { getConfigViewOptionsKey } from '~/constants/react-query-keys';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { filterOutIPTCFields } from '~/swr-hooks/gallery/viewFields/filterOutIPTCFields';
import { useCanViewPrivateAddOn } from '~/swr-hooks/workspaces/addOns/useCanViewPrivateAddOn';

export const useGetPrivateConfigViewOptions = ({ viewType }: { viewType: ViewTypeName | undefined }) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;

  const { canViewAddOn: canSeePrivateIPTCFields } = useCanViewPrivateAddOn({ key: 'metadata' });

  return useQuery({
    queryKey: getConfigViewOptionsKey({
      workspaceId: currentWorkspace?.id,
      viewType,
      canSeeIPTCFields: canSeePrivateIPTCFields,
    }),

    queryFn: async () => {
      if (!workspaceId) {
        throw new Error('No workspace id');
      }

      if (!viewType) {
        throw new Error('No view type');
      }

      const response = await Workspaces.listViewFields({ name: viewType, workspaceId });
      return canSeePrivateIPTCFields ? response : filterOutIPTCFields(response);
    },
    enabled: !!viewType && !!workspaceId,
  });
};
